<template lang="pug">
  td.col.favorite(:class="job.favored ? 'on' : ''")
    span(@click="toggle") お気に入り
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    props: ['job', 'updateFavorForIndex'],

    computed: {
      ...mapGetters('common', ['spMode']),
    },

    methods: {
      ...mapActions('jobList', ['add', 'remove']),
      async toggle () {
        const newFavored = !this.job.favored
        this.$store.commit('common/lockGlobal')
        try {
          this.job.favored
            ? await this.remove({ id: this.job.id })
            : await this.add({ id: this.job.id })

          if (this.updateFavorForIndex) {
            this.$store.commit('job/favor', { ids: this.job.id, newFavored })
            this.$store.dispatch('job/updateFavor', { detail: this.job, newFavored })
          }
          this.$store.commit('common/unlockGlobal')
          this.$emit('update')
        } catch (e) {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobATagFavoriteStar.vue